export default __webpack_public_path__ + "static/media/everyonevote.8919dfb1.mp3";